/**
 * Helper function for react-intl to flatten JSON tree.
 * @param  {JSON} nestedMessages - JSON object to be flattened
 * @param  {string} prefix - Optional prefix to control which keys are flattened (default '' does everything)
 * @return {{[key: string]: string}} Flattened JSON object
 */
import { hasAttributes } from 'neuro-utils';

const flattenMessages = (nestedMessages: NestedMessages, prefix = ''): { [key: string]: string } => {
  const messages: { [key: string]: string } = {};

  const flatten = (nested: NestedMessages, currentPrefix: string): void => {
    for (const key in nested) {
      if (hasAttributes(nested, [key])) {
        const value = nested[key];
        const newPrefix = currentPrefix ? `${currentPrefix}.${key}` : key;

        if (typeof value === 'string') {
          messages[newPrefix] = value;
        } else if (value !== undefined) {
          flatten(value, newPrefix);
        }
      }
    }
  };

  flatten(nestedMessages, prefix);

  return messages;
};

type NestedMessages = {
  [key: string]: string | NestedMessages;
};

export default flattenMessages;
